<tt-page *ngIf="!!menu">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListStocks" ltype="multi" [optionfunc]="goBackToPrevious.bind(this)"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </tt-card>

            <tt-list-legacy class="col-xs-12 col-md-8 p-5" [listItems]="itemsListStocks" ltype="multi" [optionfunc]="goBackToPrevious.bind(this)"></tt-list-legacy>
        </div>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="order_order_no" [ttModel]="menu.order_order_no" [ttButtons]="orderButtons" ttReadonly></tt-input>
        <tt-input ttLabel="stat_cust_name" [ttModel]="menu.stat_cust_name" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id" [ttModel]="menu.prod_id" ttReadonly></tt-input>
        <tt-textarea ttLabel="prod_name_long" [ttModel]="menu.prod_name_long" ttReadonly></tt-textarea>
        <tt-input-number ttLabel="quantity" [ttModel]="menu.quantity" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
    </ng-container>
</ng-template>

<!--<tt-page>
    <div class="col-xs-12 sp-0">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="order_order_no" tt-model="vm.model.menu.order_order_no" tt-change="vm.model.menu.order_order_no = $value" tt-placeholder="" tt-buttons="vm.model.orderButtons" tt-readonly="true"></tt-input-buttons>
            <tt-input class="col-xs-12 sp-0" tt-label="stat_cust_name" tt-model="vm.model.menu.stat_cust_name" tt-change="vm.model.menu.stat_cust_name = $value" tt-readonly="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="prod_id" tt-model="vm.model.menu.prod_id" tt-change="vm.model.menu.prod_id = $value" tt-readonly="true"></tt-input>
            <tt-textarea class="col-xs-12 sp-0" tt-label="prod_name_long" tt-model="vm.model.menu.prod_name_long" tt-change="vm.model.menu.prod_name_long = $value" tt-readonly="true"></tt-textarea>
            <tt-input-number class="col-xs-12 sp-0" tt-label="quantity" tt-model="vm.model.menu.quantity" tt-change="vm.model.menu.quantity = $value" tt-placeholder="" tt-style="" tt-text-align="right" tt-options="{ decimals: 0 }" tt-readonly="true"></tt-input-number>
        </tt-card>

        <im-list-directive class="col-xs-12 col-md-8 p-5" list-items="vm.model.itemsListStocks" badge="badgeinfo" ltype="multi" design-var="s12t0" optionfunc="vm.goBackToPrevious(item)"></im-list-directive>
    </div>
</tt-page>-->
